import { StateSchema } from 'app/config/storeConfig/types';
import { LeadFormModalSchema } from '../types';

export const getLeadFormModalState = (state: StateSchema): LeadFormModalSchema => state.leadFormModal;
